import React, { useContext } from 'react';
import { ModalHeader } from 'src/components/Modal/ModalHeader';
import { ModalBody } from 'src/components/Modal/ModalBody';
import { ModalFooter } from 'src/components/Modal/ModalFooter';
import { ModalStatic } from 'src/components/Modal/ModalStatic';
import { useBreakpointMatch } from 'src/hooks/useBreakpoint';
import { FilterModalContext } from 'src/components/CategoryListingPage/FilterModalContext';

import classes from './LayeredNav.scss';

type Props = {
    current: React.ReactNode;
    selections: React.ReactNode;
    onRemoveAll?: () => void;
    filtersSelected?: boolean;
};

export const LayeredNavLayout: React.FC<Props> = ({ current, selections, onRemoveAll, filtersSelected }) => {
    const { closeFilter, showFilter } = useContext(FilterModalContext);
    const { isMob } = useBreakpointMatch();

    return (
        <ModalStatic className={classes.modalNav} onDismiss={closeFilter} isOpen={showFilter} isMob={isMob}>
            <div className={classes.modalNavTop}>
                <div className={classes.modalMediumPadding}>
                    <ModalHeader
                        filter="filter-black"
                        title="All Filters"
                        removeFilters={onRemoveAll}
                        onDismiss={closeFilter}
                        filtersSelected={filtersSelected}
                    />
                    <ModalBody>
                        <div className={classes.filter}>
                            <div className={classes.filtersCurrent}>{current}</div>
                            {selections}
                        </div>
                    </ModalBody>
                </div>
            </div>
            <div className={classes.modalFooter}>
                <ModalFooter onDismiss={closeFilter} showCount={true} />
            </div>
        </ModalStatic>
    );
};
